import React, { useState } from 'react';
import Logo from '../components/navbar/Logo';
import { useNavigate } from 'react-router-dom';
import clienteAxios from '../helpers/axios.helper';
import Swal from 'sweetalert2'; // Importar SweetAlert2

function Login() {
  const [email, setEmail] = useState();
  const [contrasenia, setContrasenia] = useState();
  const [showcontrasenia, setShowContrasenia] = useState(false);
  const [error, setError] = useState(null); // Estado para manejar errores
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Llamada a la API con axios
      const response = await clienteAxios.post('/usuarios/login', {
        email,
        contrasenia,
      });

      // Suponiendo que el token viene en response.data.token
      const { token, rol } = response.data;

      // Almacenar el token en el localStorage (opcional)
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('rol', rol);

      // Mostrar alerta de éxito
      Swal.fire({
        icon: 'success',
        title: 'Inicio de sesión exitoso',
        text: 'Bienvenido de nuevo!',
      });

      // Redirigir al panel de administración
      navigate('/panel_administracion');
    } catch (error) {
      // Manejo de errores
      console.error('Error al iniciar sesión:', error.response?.data || error.message);

      // Mostrar alerta de error
      Swal.fire({
        icon: 'error',
        title: 'Error al iniciar sesión',
        text: error.response?.data?.message || 'Por favor, intenta nuevamente.',
      });

      // Establecer mensaje de error en el estado
      setError(error.response?.data?.message || 'Error al iniciar sesión. Por favor, intenta nuevamente.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-carritoshadow max-w-3xl w-full flex flex-col md:flex-row">
        <div className="flex flex-col items-center justify-center w-full md:w-1/2 pr-8 mb-4 md:mb-0">
          <Logo size="w-72" />
          <h2 className="my-4 text-lg font-semibold text-center text-GrisOscuro italic">
            "Impulsando tu campo, creciendo juntos."
          </h2>
        </div>

        <div className="hidden md:block border-r border-gray-300 mx-4"></div>

        <div className="w-full md:w-1/2 pl-0 md:pl-8">
          <h2 className="text-2xl font-bold text-center mb-4">Iniciar Sesión</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Correo Electrónico
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 block w-full px-3 py-2 border border-GrisOscuro rounded-md shadow-sm focus:outline-none focus:ring-Verde focus:border-Verde sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="contrasenia" className="block text-sm font-medium text-gray-700">
                Contraseña
              </label>
              <div className="relative">
                <input
                  type={showcontrasenia ? 'text' : 'password'}
                  id="contrasenia"
                  value={contrasenia}
                  onChange={(e) => setContrasenia(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-GrisOscuro rounded-md shadow-sm focus:outline-none focus:ring-Verde focus:border-Verde sm:text-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowContrasenia(!showcontrasenia)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-GrisOscuro hover:text-GrisOscuro focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {showcontrasenia ? (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </>
                    ) : (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                        <line x1="4" y1="4" x2="20" y2="20" />
                      </>
                    )}
                  </svg>
                </button>
              </div>
            </div>
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-Negro rounded-md shadow-sm text-base font-medium text-Blanco bg-Verde hover:bg-GrisClaro hover:text-Negro focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Iniciar Sesión
            </button>
          </form>
          {error && (
            <div className="text-red-500 text-center mt-4">{error}</div>
          )}
          <div className="text-center mt-4">
            <button
              type="button"
              className="mt-1 text-Verde hover:text-Negro font-medium"
              onClick={() => navigate('/registro')}
            >
              Registrarse
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
